import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Button,
	Alert,
	Platform,
	ImageBackground,
	Image,
	AsyncStorage,
} from "react-native";

import SafeAreaView from "components/third-party/react-native-safe-area-view"

import { autoLogin, refresh } from "utils/awsAuth";
import { reset } from "utils/navigation";


import * as x from "../../styles/css";

class SplashScreen extends Component {
	componentDidMount() {
		autoLogin()
			.then(resp => {
				setTimeout(() => {
					reset({ web: "/", mobile: "Home" }, this.props);
				}, 1500);
			})
			.catch(err => {
				setTimeout(() => {
					refresh()
						.then(resp => {
							reset({ web: "/", mobile: "Home" }, this.props);
							return;
						})
						.catch(err => {
							console.log(err);
							reset({ web: "/login", mobile: "Login" }, this.props);
						});
				}, 1500);
			});
	}

	render() {
		return (
			<View style={[x.d.flex]}>
				<ImageBackground
					style={[
						x.d.flex,
						x.justifyContent.center,
						x.alignItems.center,
						{ height: "100%", width: "100%" },
					]}
					resizeMode="cover"
					blurRadius={1}
					source={require("assets/bg.fw.jpg")}
				>
					<SafeAreaView style={[
						x.d.flex,
						x.justifyContent.center,
						x.alignItems.center,
						{ height: "100%", width: "100%" },
					]}>
					<Image
						source={require("assets/logoW.png")}
						style={{
							marginTop: "auto",
							flex: 0,
							resizeMode: "contain",
							height: "95%",
							width: "95%",
							maxHeight: 150,
							maxWidth: 500,
						}}
					/>
					<View
						style={{
							backgroundColor: "rgba(0,0,0,0)",
							marginTop: "auto",
							marginBottom: 5,
						}}
					>
						<Text style={{ fontSize: 24, color: "white" }}>
							{"Feels Good... Naturally"}
						</Text>
					</View>
					</SafeAreaView>
				</ImageBackground>
			</View>
		);
	}
}

export default SplashScreen;



// WEBPACK FOOTER //
// ./src/views/SplashScreen/index.js